module.exports = __webpack_public_path__ + "99cd8c30cd93d9b620fd25a9e11ffc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.png
// module id = 1145
// module chunks = 0